import { FC, PropsWithChildren } from 'react'
import {
  FeatureFlagController,
  FeatureFlagDescriptor,
  FeatureFlagToggle,
  PageSpinner,
  TestFeatureFlag,
} from '@signifyd/legacy-components'
import { User } from '@signifyd/http'

interface Props {
  user: User
  testFeatureFlags?: TestFeatureFlag
}

export const HAS_NEW_CONFIRMATION_DESTINATION_FIELDS_IN_ADMIN_KEY =
  'has-new-confirmation-destination-fields-in-admin'

export const HAS_RECOMMENDATION_MR_KEY = 'has-recommendation-mr'

type CaseReviewFeatureFlagKey =
  | typeof HAS_NEW_CONFIRMATION_DESTINATION_FIELDS_IN_ADMIN_KEY
  | typeof HAS_RECOMMENDATION_MR_KEY

type CaseReviewFeatureFlagConfig = FeatureFlagDescriptor & {
  key: CaseReviewFeatureFlagKey
}

export const caseReviewFeatureFlagConfig: Array<CaseReviewFeatureFlagConfig> = [
  {
    key: HAS_NEW_CONFIRMATION_DESTINATION_FIELDS_IN_ADMIN_KEY,
    label: 'New Confirmation/Destination Fields',
  },
  {
    key: HAS_RECOMMENDATION_MR_KEY,
    label: 'Recommendation MR',
  },
]

const CaseReviewFeatureFlagController: FC<PropsWithChildren<Props>> = ({
  user,
  testFeatureFlags,
  children,
}) => {
  return (
    <FeatureFlagController
      user={user}
      featureFlagConfig={caseReviewFeatureFlagConfig}
      LoadingComponent={<PageSpinner />}
      testFeatureFlags={testFeatureFlags}
    >
      <FeatureFlagToggle />
      {children}
    </FeatureFlagController>
  )
}

export default CaseReviewFeatureFlagController
